import { FC } from 'react';
import { PageTitle } from '../../../rbts/layout/core';
import { View } from './components/View';

const ProveedoresPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Proveedores</PageTitle>
      <View />
    </>
  );
};

export { ProveedoresPage };
